import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export function SingleListViewItemSkeleton({className, ...props}: Props) {
  return (
    <div
      className={twMerge(
        'flex h-96pxr space-x-10pxr py-8pxr px-15pxr',
        className
      )}
      {...props}
    >
      <div className="h-80pxr w-56pxr rounded-5pxr bg-theme-etc-skeleton" />
      <div className="flex flex-col items-start justify-center space-y-8pxr">
        <div className="h-16pxr w-96pxr rounded-3pxr bg-theme-etc-skeleton" />
        <div className="h-16pxr w-216pxr rounded-3pxr bg-theme-etc-skeleton" />
      </div>
    </div>
  );
}
